import { getAuth } from "firebase/auth";
import { Navigate } from "react-router-dom";
import { useEffect, useState } from "react";
import checkAccess from "./CheckAccess"; // your util

const ProtectedRoute = ({ children, object, action }) => {
  const [userChecked, setUserChecked] = useState(false);
  const [hasPermission, setHasPermission] = useState(false);

  useEffect(() => {
    const auth = getAuth();
    const user = auth.currentUser;
    if (!user) {
      setUserChecked(true);
      setHasPermission(false);
      return;
    } 

    const allowed = checkAccess(object, action);
    setHasPermission(allowed);
    setUserChecked(true);
  }, [object, action]);

  if (!userChecked) return <div>Checking access...</div>;

  return hasPermission ? children : <Navigate to="/unauthorized" />;
};

export default ProtectedRoute